import { AuthService } from './../../shared/models/auth.service';
import { TermsConditionModel } from './terms-condition.model';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { SearchFilterModel } from "../models/search-filter.model";

@Injectable()
export class TermsAndConditionsService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetTermsAndConditionList(termsAndConditionSearchList: TermsConditionModel, input?: DataListModel): Observable<IAPIResponse> {
    let getTermsAndConditionListUrl = WeGoConfig.API_GET_TERMSANDCONDITIONS_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    let queryStringTermsAndConditionModel = this.JQueryHelper.Param(termsAndConditionSearchList);
    getTermsAndConditionListUrl = getTermsAndConditionListUrl + "?" + queryString + "&" + decodeURIComponent(queryStringTermsAndConditionModel);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getTermsAndConditionListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportTermsAndConditionList(termsAndConditionSearchList: TermsConditionModel, input?: DataListModel): any {
    let getUrl = WeGoConfig.API_EXPORT_TERMSANDCONDITIONS_LIST;
    input.currentPage = 0;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringTermsConditionModel = this.JQueryHelper.Param(termsAndConditionSearchList);
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    getUrl = getUrl + "?" + queryStringDataListModel + "&" + decodeURIComponent(queryStringTermsConditionModel);
    return this.http.get(getUrl, options);
  }

  public UpdateTermsAndConditions(termsAndConditionSearchList: TermsConditionModel): Observable<IAPIResponse> {
    let body = termsAndConditionSearchList;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_POST_TERMSANDCONDITIONS_DETAILS, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetTermsAndConditionsByHashId(termsAndConditionsHashId: string): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_TERMSANDCONDITIONS_BY_HASH + "?termsAndConditionHashId=" + termsAndConditionsHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInstanceListDropdownList(
    permissionType: string,
    termsAndConditionsHashId?: string,
    pageName?: string
  ): Observable<IAPIResponse> {
    let getTermsConditionUrl: string;

    getTermsConditionUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS;

    getTermsConditionUrl = getTermsConditionUrl + "?permissionType=" + permissionType + "&termsAndConditionsHashId=" + termsAndConditionsHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getTermsConditionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteTermsAndConditions(selectedTermsAndConditions: string[]): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_DELETE_TERMSANDCONDITIONS, selectedTermsAndConditions, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public GetTermsAndConditionActivityList(termsAndConditionsHashId: string, input?: DataListModel): Observable<IAPIResponse> {
    let getTermsAndConditionListUrl = WeGoConfig.API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    getTermsAndConditionListUrl = getTermsAndConditionListUrl + "?" + queryString + "&termsAndConditionHashId=" + termsAndConditionsHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getTermsAndConditionListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetTermsAndConditionActivityListDriver(input?: DataListModel): Observable<IAPIResponse> {
    let getTermsAndConditionListUrl = WeGoConfig.API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER;
    let queryString = this.authService.HandleAPIListInput(input);

    getTermsAndConditionListUrl = getTermsAndConditionListUrl + "?" + queryString;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getTermsAndConditionListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportTermsAndConditionActivityList(termsAndConditionsHashId: string, input?: DataListModel): any {
    let getUrl = WeGoConfig.API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST;
    input.currentPage = 0;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);

    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    getUrl = getUrl + "?" + queryStringDataListModel + "&termsAndConditionHashId=" + termsAndConditionsHashId;
    return this.http.get(getUrl, options);
  }

  public ExportTermsAndConditionActivityListDriver(input?: DataListModel): any {
    let getUrl = WeGoConfig.API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER;
    input.currentPage = 0;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);

    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    getUrl = getUrl + "?" + queryStringDataListModel;
    return this.http.get(getUrl, options);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/models/terms-conditions.service.ts